export const extractValues = (enumValues) => {
    return enumValues?.map(function (item) {
        return item["value"];
    });
};
